var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-action-bar"},[_c('pss-button',{attrs:{"text":"提交"},on:{"on-click":_vm.submitExamApprovalHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }